import { P } from "apparatus/library/common";
import { MoveIndividual } from "editing/move";
export var Distribute;
(function (Distribute) {
    function distributeCenters(components, axis) {
        if (components.length <= 2)
            return;
        // Sort components by their centers.
        components.sort((a, b) => a.alignmentBounds.center[axis] - b.alignmentBounds.center[axis]);
        // Get the extremities and determine step.
        const high = components[components.length - 1].alignmentBounds.center[axis];
        const low = components[0].alignmentBounds.center[axis];
        const step = (high - low) / (components.length - 1);
        // Move each component to desired new location.
        return new MoveIndividual(components.map((c, i) => {
            const moveTo = low + step * i;
            var delta = P(0, 0);
            delta[axis] = moveTo - c.alignmentBounds.center[axis];
            return { id: c.id, delta };
        }));
    }
    Distribute.distributeCenters = distributeCenters;
    function distributeGaps(components, axis) {
        if (components.length <= 2)
            return;
        let lowEdge = axis == "x" ? "left" : "top";
        let highEdge = axis == "x" ? "right" : "bottom";
        let sizeProperty = axis == "x" ? "width" : "height";
        // Sort components by their centers.
        components.sort((a, b) => a.alignmentBounds.center[axis] - b.alignmentBounds.center[axis]);
        // Calculate total gap.
        var totalGap = 0;
        for (let i = 0; i < components.length - 1; i++) {
            totalGap += components[i + 1].alignmentBounds[lowEdge] - components[i].alignmentBounds[highEdge];
        }
        const gapStep = totalGap / (components.length - 1);
        // Move each component to desired new location.
        var desiredLowEdge = components[0].alignmentBounds[lowEdge];
        return new MoveIndividual(components.map((c, _) => {
            var delta = P(0, 0);
            delta[axis] = desiredLowEdge - c.alignmentBounds[lowEdge];
            // Compute the next desired edge.
            desiredLowEdge += c.alignmentBounds[sizeProperty] + gapStep;
            return { id: c.id, delta };
        }));
    }
    Distribute.distributeGaps = distributeGaps;
})(Distribute || (Distribute = {}));
